import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import { qk } from '@/lib/queryKeys'
import type { Category, Subcategory, Town } from '@/types/api'

const HOUR = 60 * 60 * 1000

/** GET /towns — town selector with shop counts. Rarely changes → long staleTime. */
export const townsQuery = queryOptions({
  queryKey: qk.towns,
  queryFn: ({ signal }) => api<Town[]>('/towns/', { signal }),
  staleTime: HOUR,
})

export const useTowns = () => useQuery(townsQuery)

/** GET /categories/{slug}/subcategories/ — chips of sub-categories with products (D-81). */
export const useSubcategories = (slug: string, town: string | null) =>
  useQuery({
    queryKey: qk.subcategories(slug, town),
    queryFn: ({ signal }) =>
      api<Subcategory[]>(`/categories/${slug}/subcategories/`, { query: { town }, signal }),
    staleTime: 5 * 60 * 1000,
    enabled: slug !== '',
  })

/** GET /categories — Home icon grid (main categories). */
export const useCategories = () =>
  useQuery({
    queryKey: qk.categories,
    queryFn: ({ signal }) => api<Category[]>('/categories/', { signal }),
    staleTime: HOUR,
  })
